export default {
  WaterMinimum: 0.1999
};
